<template>
    <div
        class="relative gap-6 justify-center h-auto "
        :class="containerless ? 'col-span-full grid grid-cols-subgrid' : 'container grid grid-cols-12 w-full'"
        ref="elementRef"
    >
        <div
            v-if="content"
            class="md:col-start-2 col-span-full md:col-span-5 ease-linear duration-75 flex flex-col items-center justify-center translate-y-0 md:[translate:0px_var(--ty)]"
            :style="{ '--ty': `${50 * normalized}px` }"
        >
            <img
                :src="`/api/files/image/${content?.['image-left']}`"
                class="self-end w-full rounded-sm"
            />
            <div class="self-start text-caption text-dark-blue/75 ">{{content?.['text-left']?.[mainStore.active_locale]}}</div>
        </div>
        <div
            class="col-span-full md:col-span-5 flex flex-col items-center justify-center translate-y-0 md:[translate:0px_var(--ty)]"
            :style="{ '--ty': `${50 * normalized * -1}px` }"
        >
            <img
                :src="`/api/files/image/${content?.['image-right']}`"
                class="self-start w-full rounded-sm"
            />
            <div class="self-start text-caption text-dark-blue/75 ">{{content?.['text-right']?.[mainStore.active_locale]}}</div>
        </div>

<!--        <div class="absolute top-0 left-0 z-100 bg-white">{{ distance }}, {{ normalized }}</div>-->
    </div>
</template>

<script lang="ts" setup>

const elementRef = ref(null)
const { distance, normalized, isVisible } = useDistanceFromCenter(elementRef)
const mainStore = useMainStore()

// import { generateHTML } from "@tiptap/vue-3"
// import StarterKit from "@tiptap/starter-kit"
// import { Color, TextStyle } from "@tiptap/extension-text-style"
//
// const renderedHTML = ref('')
//
const props = defineProps({
    content: {
        type: Object as PropType<{'image-left': string, 'text-left'?: string, 'image-right': { nl_NL: string, en_GB: string }, 'text-right'?: string}>
    },
    containerless: {
        type: Boolean,
        default: false
    }
})
//
// const emit = defineEmits(['enter', 'leave'])
//
// const { elementRef, isInViewport } = useInViewport({
//     threshold: 0.5,
//     onEnter: () => emit('enter'),
//     onLeave: () => emit('leave'),
// })
//
// onMounted(() => {
//     renderedHTML.value = generateHTML(props.content?.['body'], [
//         StarterKit,
//         TextStyle,
//         Color
//     ])
// })


</script>

<!--<style scoped lang="scss">-->
<!--</style>-->
